var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0303 6.53033C14.3232 6.23744 14.3232 5.76256 14.0303 5.46967L9.25736 0.696699C8.96447 0.403806 8.48959 0.403806 8.1967 0.696699C7.90381 0.989592 7.90381 1.46447 8.1967 1.75736L12.4393 6L8.1967 10.2426C7.90381 10.5355 7.90381 11.0104 8.1967 11.3033C8.48959 11.5962 8.96447 11.5962 9.25736 11.3033L14.0303 6.53033ZM0.5 6.75H13.5V5.25H0.5V6.75Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4642a5fe53f16207510920f405400920.svg";
export { ForwardRef as ReactComponent };